import { Box, Button, Center, Flex, Icon, IconButton, SimpleGrid, Spacer, Text, useDisclosure, useToast } from '@chakra-ui/react'

import { TbDots } from 'react-icons/tb'
import CalendarLarge, { getEventsOfTheDay } from '../../components/calendar/CalendarLarge'
import Datagrid from '../../components/datagrid/Datagrid'

import { getEvents } from '../../api/user/events/Events'
import { patchEventCheckIn } from '../../api/user/play/Play'

import { useQuery } from 'react-query'
import UserSelectModal from '../../components/modals/UserSelectModal'

import { GoogleMap, OverlayView, OverlayViewF } from '@react-google-maps/api'
import useGoogleMaps from '../../hooks/useGoogleMaps'
import { useCallback, useEffect, useMemo, useState } from 'react'
import LazyBox from '../../components/lazy/LazyBox'
import { mapContainerStyle, mapStyles } from '../../theme/mapStyles'

import { Skeleton } from '@chakra-ui/react'
import EventDetailCard from '../../components/cards/EventDetailCard'

import EventDetailHostCard from '../../components/cards/EventDetailHostCard'
import { getInfinityPages } from '../../components/datagrid/InfinityGrid'
import { ArrowLeft, MessagesFilled } from '../../components/icons/icons'
import BlankState from '../../components/input/BlankState'
import BulkEditEventsModal from '../../components/modals/BulkEditEventsModal'
import { buildBookedList } from '../../functions/buildBookedList'
import { getSkillLevelDisplay } from '../../functions/Capitalize'
import handleToast from '../../components/toast/handleToast'
import { getCourtDisplayName } from '../../functions/CourtName'
import useMobile from '../../hooks/useMobile'
import { getEventLabel } from '../../types/EventTypes'

// const SKILL_LEVELS: any = ['Beginner', 'Intermediate', 'Intermediate High', 'Advanced', 'Advanced 4.5+', 'Mixed-Level']

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export function formatDuration(start: Date, end: Date): string {
  const durationInMilliseconds = end.getTime() - start.getTime()
  const totalMinutes = Math.floor(durationInMilliseconds / (1000 * 60))
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  let durationString = ''

  if (hours > 0 && minutes > 0) {
    // Both hours and minutes are non-zero
    durationString = `${hours} ${hours === 1 ? 'hour' : 'hours'} and ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`
  } else if (hours > 0 && minutes === 0) {
    // Only hours are non-zero
    durationString = `${hours} ${hours === 1 ? 'hour' : 'hours'}`
  } else if (hours === 0 && minutes > 0) {
    // Only minutes are non-zero
    durationString = `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`
  } else {
    // Both hours and minutes are zero
    durationString = '0 minutes'
  }

  return durationString
}

export function formatTimeRange(start: Date, end: Date): string {
  let startTime = start.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true })
  let endTime = end.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true })

  if (start.getHours() === 12) {
    startTime = `12:${start.getMinutes().toString().padStart(2, '0')} pm`
  }
  if (end.getHours() === 12) {
    endTime = `12:${end.getMinutes().toString().padStart(2, '0')} pm`
  }

  const timeRange = `${startTime} - ${endTime}`

  return `${timeRange}`
}

const getPixelPositionOffset = (width: any, _height: any) => ({
  x: -(width / 2),
  y: -98,
})

const MapPin = ({ images }: { images: string[] }) => {
  return (
    <LazyBox
      width={60}
      height={60}
      src={images.length > 0 ? images[0] : ''}
      borderRadius="30px"
      position="absolute"
      top="15px"
      left="15px"
    />
  )
}

export const MapSection = ({
  venues,
  selectedEvent,
  onChange,
}: {
  venues: any
  selectedEvent: any
  onChange: (v: any) => void
}) => {
  const { isLoaded } = useGoogleMaps()

  //const [map, setMap] = useState(null)
  // const [zoom, setZoom] = useState(8)
  // const [center, setCenter] = useState({
  //     lat: venues[0]?.location?.lat ?? 34.052235,
  //     lng: venues[0]?.location?.lng ?? -118.243683,
  // })

  const zoom = 12
  const center = useState({
    lat: venues[0]?.location?.lat ?? 34.052235,
    lng: venues[0]?.location?.lng ?? -118.243683,
  })[0]

  const onLoad = useCallback(function callback(map: any) {
    //const bounds = new window.google.maps.LatLngBounds(center);
    map.setZoom(12)
    //setMap(map)
  }, [])
  const onUnmount = useCallback(function callback() {
    //setMap(null)
  }, [])

  return (
    <>
      {/* {selectedEvent !== null && <>
        {
            isMobile ? <>
            <EventDetailCard
                status="hosted"
                time={}

            />
            
            </> : <>
            </>
        }
        </>} */}
      {isLoaded ? (
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={center}
          onLoad={onLoad}
          zoom={zoom}
          onUnmount={onUnmount}
          options={{
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            zoomControl: false,
            styles: mapStyles,
            minZoom: zoom - 5,
          }}
        >
          {venues.map((row: any, index: number) => {
            return (
              <Box>
                <OverlayViewF
                  key={index}
                  position={{
                    lat: row?.location?.lat ?? 0,
                    lng: row?.location?.lng ?? 0,
                  }}
                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                  getPixelPositionOffset={getPixelPositionOffset}
                >
                  <Box
                    position="relative"
                    w="90px"
                    h="107px"
                    bgImage="/components/map_pin.svg"
                    bgPos="center"
                    bgSize="contain"
                    cursor="pointer"
                    onClick={() =>
                      row.first_event.id != (selectedEvent?.id ?? '')
                        ? onChange({
                            ...row.first_event,
                            address: row.address,
                            image: row.images.length > 0 ? row.images[0] : '',
                          })
                        : onChange(null)
                    }
                    //onMouseLeave={() => setHoveredPin("")}
                  >
                    <MapPin images={row.images} />
                  </Box>
                </OverlayViewF>
              </Box>
            )
          })}
        </GoogleMap>
      ) : (
        <Skeleton w="100%" h="100%" />
      )}
    </>
  )
}

const EventsSection = ({
  isTablet,
  displayType,
  events: _events,
  venues,
  params,
  onExtraOptionsOpen,
  setCurrentEventId,
  setCurrentEventDate,
  currentEventId,
  isPlayerGroupMessageOpen,
  onClosePlayerGroupMessage,
  onOpenPlayerGroupMessage,
}: {
  isTablet?: boolean
  displayType: string
  events: any
  venues: any
  params: any
  onExtraOptionsOpen: () => void
  setCurrentEventId: (event_id: string) => void
  setCurrentEventDate: (date: Date) => void
  currentEventId: string
  isPlayerGroupMessageOpen: boolean
  onClosePlayerGroupMessage: () => void
  onOpenPlayerGroupMessage: () => void
}) => {
  const currentDate = new Date()
  const currentMonth = currentDate.getMonth()
  const toast = useToast()

  const [month, setMonth] = useState(currentMonth)
  const [year, setYear] = useState(currentDate.getFullYear())
  const [page, setPage] = useState(1)

  const [showCalendarEvents, setShowCalendarEvents] = useState(false)
  const [eventsOfTheDay, setEventsOfTheDay] = useState<any[]>([])
  const [dateOfEvents, setDateOfEvents] = useState<string>('')

  const eventsListed = useQuery(['getEvents', params, page], () =>
    getEvents({
      ...params,
      coaches: params.coach.map((c: any) => c.id).join(','),
      page,
      page_size: 10,
    })
  )

  // Separate query for calendar - fetch all events for the visible month range
  const calendarEndDate = new Date(year, month + 1, 0)

  const calendarEvents = useQuery(
    ['getCalendarEvents', params, month, year],
    () =>
      getEvents({
        ...params,
        coaches: params.coach.map((c: any) => c.id).join(','),
        min_date: `${year}-${String(month + 1).padStart(2, '0')}-01`,
        max_date: `${year}-${String(month + 1).padStart(2, '0')}-${String(calendarEndDate.getDate()).padStart(2, '0')}`,
        page: 1,
        page_size: 1000, // Large page size to get all events for the month
      }),
    {
      enabled: displayType === 'calendar', // Only fetch when calendar view is active
    }
  )

  const [selectedEvent, setSelectedEvent] = useState<any | null>(null)

  const isSmallTablet = useMobile(840)

  const {
    isOpen: isCoachGroupMessageOpen,
    onOpen: onOpenCoachGroupMessage,
    onClose: onCloseCoachGroupMessage,
  } = useDisclosure()

  const isMobile = useMobile(600)

  const currentEventParticipants = useMemo(() => {
    return eventsListed.data?.events
      ?.find((e: any) => e.id === currentEventId)
      ?.participants ?? []
  }, [eventsListed.data, currentEventId])

  const [checkedInIds, setCheckedInIds] = useState<Set<string>>(new Set())
  const [selectedEventIds, setSelectedEventIds] = useState<string[]>([])
  const {
    isOpen: isBulkEditOpen,
    onOpen: onBulkEditOpen,
    onClose: onBulkEditClose,
  } = useDisclosure()

  useEffect(() => {
    setCheckedInIds(
      new Set(
        currentEventParticipants
          .filter((p: any) => p.checked_in && p.booking_id)
          .map((p: any) => p.booking_id as string)
      )
    )
  }, [currentEventParticipants])

  useEffect(() => {
    const visibleIds = (eventsListed.data?.events ?? []).map((event: any) => event.id)
    setSelectedEventIds((prev) => prev.filter((id) => visibleIds.includes(id)))
  }, [eventsListed.data?.events, displayType])

  const handleCheckIn = async (bookingId: string, checked: boolean) => {
    if (!currentEventId) return
    setCheckedInIds((prev) => {
      const next = new Set(prev)
      if (checked) next.add(bookingId)
      else next.delete(bookingId)
      return next
    })
    try {
      await patchEventCheckIn({ event_id: currentEventId, booking_id: bookingId, checked_in: checked })
    } catch (e) {
      console.error('Check-in failed', e)
      // Recompute from the source participants rather than restoring a stale
      // closure snapshot, so rapid toggles don't roll back other rows (CR-02).
      setCheckedInIds(
        new Set(
          currentEventParticipants
            .filter((p: any) => p.checked_in && p.booking_id)
            .map((p: any) => p.booking_id as string)
        )
      )
      handleToast(toast, 'Check-in failed. Try again.')
    }
  }

  const visibleEventIds = (eventsListed.data?.events ?? []).map((event: any) => event.id)
  const allVisibleSelected = visibleEventIds.length > 0 && visibleEventIds.every((id: string) => selectedEventIds.includes(id))
  const someVisibleSelected = selectedEventIds.length > 0 && visibleEventIds.some((id: string) => selectedEventIds.includes(id)) && !allVisibleSelected

  const toggleEventSelection = (eventId: string) => {
    setSelectedEventIds((prev) => (prev.includes(eventId) ? prev.filter((id) => id !== eventId) : [...prev, eventId]))
  }

  const toggleAllVisibleEvents = () => {
    setSelectedEventIds((prev) =>
      allVisibleSelected ? prev.filter((id) => !visibleEventIds.includes(id)) : Array.from(new Set([...prev, ...visibleEventIds]))
    )
  }

  return (
    <Box p={isTablet ? '20px' : '30px'}>
      <BulkEditEventsModal
        isOpen={isBulkEditOpen}
        onClose={onBulkEditClose}
        eventIds={selectedEventIds}
        onSuccess={() => {
          setSelectedEventIds([])
          eventsListed.refetch()
          calendarEvents.refetch()
        }}
      />
      <UserSelectModal
        isMobile={isMobile}
        isOpen={isPlayerGroupMessageOpen}
        onClose={onClosePlayerGroupMessage}
        onChange={() => {}}
        title="All players"
        users={buildBookedList(currentEventParticipants, null).map((player) => ({
          id: player.id,
          name: player.display_name,
          avatar: player.profile_image,
          follows: player.follows,
          is_child: player.is_child,
          booking_id: player.booking_id,
          attribution: player.is_child && player.guardianName ? 'with ' + player.guardianName : '',
        }))}
        enableCheckIn={true}
        checkedInIds={checkedInIds}
        onCheckIn={handleCheckIn}
        customIcon={
          <Icon w="20px" h="20px" viewBox="0 0 24 24">
            <MessagesFilled />
          </Icon>
        }
      />
      <UserSelectModal
        isMobile={isMobile}
        isOpen={isCoachGroupMessageOpen}
        onClose={onCloseCoachGroupMessage}
        onChange={() => {}}
        title="All coaches"
        users={
          eventsListed.data?.events
            .find((e: any) => e.id === currentEventId)
            ?.coaches.map((player: any) => {
              return { id: player.id, name: player.display_name, avatar: player.profile_image }
            }) ?? []
        }
        customIcon={
          <Icon w="20px" h="20px" viewBox="0 0 24 24">
            <MessagesFilled />
          </Icon>
        }
      />

      {displayType === 'calendar' &&
        (showCalendarEvents ? (
          <>
            <Flex alignItems="center" gap="16px" mb="16px">
              <IconButton
                minW="34px"
                h="34px"
                variant="light"
                aria-label="new chat"
                onClick={() => setShowCalendarEvents(false)}
                icon={
                  <Icon width="20px" height="19px" viewBox="0 0 23 20">
                    <ArrowLeft color="#171C22" />
                  </Icon>
                }
              />
              <Text fontSize="lg">{dateOfEvents}</Text>
            </Flex>
            <SimpleGrid
              templateColumns="repeat(auto-fit, minmax(100%, 0.2fr))"
              templateRows="auto"
              spacingX="32px"
              spacingY={'24px'}
            >
              {eventsOfTheDay.map((event: any, index: number) => {
                return (
                  <EventDetailCard
                    key={index}
                    id={event.id}
                    status={'hosted'}
                    time={new Date(event.start_time)}
                    type={event.type}
                    court={event.court}
                    secondary_type={event.secondary_type}
                    level={getSkillLevelDisplay(event.skill_level)}
                    host={event.host}
                    title={event.title}
                    coaches={event.coaches}
                    players={event.participants}
                    description={event?.description ?? ''}
                    price={event.fee}
                    duration={formatDuration(new Date(event.start_time), new Date(event.end_time))}
                    onOpenWaitlist={() => {}}
                    thumbnail={event.venue.images.length > 0 ? event.venue.images[0] : ''}
                    location={event.venue.address}
                    locationName={event.venue.name}
                    //waitlistPosition={row.status?.position}
                    onExtraOptionsOpen={() => {
                      setCurrentEventId(event.id)
                      // Prefer full_start_time (offset-aware). Building a Date
                      // from the venue-local naive start_time anchors it to
                      // the browser tz, which makes the past/future check in
                      // Events.tsx flip at the wrong instant for hosts outside
                      // the venue timezone — losing legitimate edit/cancel
                      // options or surfacing them after the cutoff.
                      setCurrentEventDate(new Date(event.full_start_time ?? event.start_time))
                      onExtraOptionsOpen()
                    }}
                  />
                )
              })}
            </SimpleGrid>
          </>
        ) : (
          <Box position="relative" mb="250px">
            <CalendarLarge
              month={month}
              year={year}
              setMonth={setMonth}
              setYear={setYear}
              events={calendarEvents.data ?? { events: [] }}
              isLoading={calendarEvents.isLoading}
              onExtraOptionsOpen={(event_id: string) => {
                const event = calendarEvents.data?.events?.find((e: any) => e.id === event_id)
                if (event) {
                  setCurrentEventId(event_id)
                  // full_start_time is offset-aware; falls back to naive
                  // start_time if the endpoint doesn't expose it yet.
                  setCurrentEventDate(new Date(event.full_start_time ?? event.start_time))
                  onExtraOptionsOpen()
                }
              }}
              onShowEventsOfTheDay={(day: number, month: number, year: number) => {
                setDateOfEvents(`${MONTH_NAMES[month]} ${day}, ${year}`)
                setEventsOfTheDay(getEventsOfTheDay(day, month, year, calendarEvents.data))
                setShowCalendarEvents(true)
              }}
            />
          </Box>
        ))}
      {displayType === 'list' && (
        <>
          {selectedEventIds.length > 0 && (
            <Flex
              position="sticky"
              top="12px"
              zIndex={2}
              mb="16px"
              p="14px 16px"
              border="1px solid #DCE2EA"
              borderRadius="12px"
              bg="white"
              boxShadow="0px 12px 40px rgba(43, 44, 45, 0.08)"
              alignItems="center"
              gap="12px"
            >
              <Text variant="title" fontSize="md">
                {selectedEventIds.length} selected
              </Text>
              <Spacer />
              <Button variant="light" onClick={() => setSelectedEventIds([])}>
                Clear Selection
              </Button>
              <Button variant="heavy" onClick={onBulkEditOpen}>
                Bulk Edit
              </Button>
            </Flex>
          )}
          {eventsListed.data?.events.length == 0 && !eventsListed.isLoading ? (
            <Center>
              <BlankState
                title="No events available"
                description="No events at the moment"
                image="/blank/There are no events to be found.svg"
              />
            </Center>
          ) : (
            <Datagrid
              headers={[
                <Box key="select-all">
                  <input
                    type="checkbox"
                    checked={allVisibleSelected}
                    ref={(node) => {
                      if (node) node.indeterminate = someVisibleSelected
                    }}
                    onChange={toggleAllVisibleEvents}
                  />
                </Box>,
                'Location',
                'Title',
                'Date',
                'Time',
                'Event Type',
                'Secondary Type',
                'Court',
                'Level',
                'Hosting',
                'Coaches',
                'Players',
                'Actions',
              ]}
              isLoading={eventsListed.isLoading}
              data={
                eventsListed?.data?.events.map((event: any, index: number) => {
                  return [
                    {
                      type: 'element',
                      element: (
                        <input
                          type="checkbox"
                          checked={selectedEventIds.includes(event.id)}
                          onChange={() => toggleEventSelection(event.id)}
                        />
                      ),
                    },
                    {
                      type: 'event',
                      id: event.id,
                      name: event.venue.name,
                      thumbnail: event.venue.images.length > 0 ? event.venue.images[0] : '',
                      location: event.venue.address,
                      duration: formatDuration(new Date(event.full_start_time || event.start_time), new Date(event.full_end_time || event.end_time)),
                      price: event.fee,
                    },
                    {
                      type: 'string',
                      label: event.title,
                    },
                    {
                      type: 'string',
                      label: new Date(event.full_start_time || event.start_time).toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        ...(event.venue?.timezone_name ? { timeZone: event.venue.timezone_name } : {}),
                      }),
                    },

                    {
                      type: 'string',
                      label: (() => {
                        const tz = event.venue?.timezone_name
                        const opts: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: '2-digit', hour12: true, ...(tz ? { timeZone: tz } : {}) }
                        const start = new Date(event.full_start_time || event.start_time)
                        const end = new Date(event.full_end_time || event.end_time)
                        return `${start.toLocaleTimeString([], opts)} - ${end.toLocaleTimeString([], opts)}`
                      })(),
                    },
                    {
                      type: 'string',
                      label: getEventLabel(event.type),
                    },
                    {
                      type: 'string',
                      label: getEventLabel(event.secondary_type),
                    },
                    {
                      type: 'string',
                      label: getCourtDisplayName(event.court) || 'Not set',
                    },
                    {
                      type: 'string',
                      label: getSkillLevelDisplay(event.skill_level),
                    },
                    {
                      type: 'users',
                      allowAdd: false,
                      users: [
                        {
                          id: event.host.id,
                          name: event.host.display_name,
                          avatar: event.host.profile_image,
                        },
                      ],
                    },
                    {
                      type: 'users',
                      allowAdd: false,
                      onClick: () => {
                        setCurrentEventId(event.id)
                        onOpenCoachGroupMessage()
                      },
                      users: event.coaches.map((coach: any) => {
                        return {
                          id: coach.id,
                          name: coach.display_name,
                          avatar: coach.profile_image,
                        }
                      }),
                    },
                    {
                      type: 'users',
                      allowAdd: false,
                      onClick: () => {
                        setCurrentEventId(event.id)
                        onOpenPlayerGroupMessage()
                      },
                      users:
                        event?.participants?.map((coach: any) => {
                          return {
                            id: coach.id,
                            name: coach.display_name,
                            avatar: coach.profile_image,
                          }
                        }) ?? [],
                    },
                    {
                      type: 'element',
                      element: (
                        <IconButton
                          key={index}
                          aria-label="options"
                          icon={<Icon w="22px" h="22px" as={TbDots} />}
                          color="#171C22"
                          variant="unstyled"
                          onClick={() => {
                            setCurrentEventId(event.id)
                            setCurrentEventDate(new Date(event.full_start_time ?? event.start_time))

                            onExtraOptionsOpen()
                          }}
                        />
                      ),
                    },
                  ]
                }) ?? []
              }
              dateRange={null}
              page={page}
              pages={eventsListed.data?.totalPages}
              onPageChange={(p) => setPage(p)}
            />
          )}
        </>
      )}
      {displayType === 'map' && (
        <Box
          w="100%"
          h="calc(100vh - 260px)"
          bg="black"
          borderRadius="10px"
          boxShadow="0px 12.914606094360352px 86.71235656738281px 0px #2B2C2D14"
          position="relative"
          overflow="hidden"
        >
          <MapSection
            venues={getInfinityPages(venues, 'venues') ?? []}
            selectedEvent={selectedEvent}
            onChange={setSelectedEvent}
          />
          {selectedEvent !== null && isSmallTablet ? (
            <Box position="absolute" bottom="0" w="100%" m="10px" pr="20px">
              <EventDetailCard
                id={selectedEvent.id}
                status={'hosted'}
                time={new Date(selectedEvent.start_time)}
                type={selectedEvent.type}
                secondary_type={selectedEvent.secondary_type}
                key={selectedEvent.id}
                title={selectedEvent.title}
                court={selectedEvent.court}
                level={getSkillLevelDisplay(selectedEvent.skill_level)}
                host={selectedEvent.host}
                coaches={selectedEvent.coaches}
                players={selectedEvent.participants}
                description={selectedEvent?.description ?? ''}
                price={selectedEvent.fee}
                duration={selectedEvent.duration}
                onOpenWaitlist={() => {}}
                thumbnail={selectedEvent.image}
                location={selectedEvent.address}
                locationName={selectedEvent.title}
                onExtraOptionsOpen={() => {
                  setCurrentEventId(selectedEvent.id)
                  setCurrentEventDate(new Date(selectedEvent.full_start_time ?? selectedEvent.start_time))
                  onExtraOptionsOpen()
                }}
              />
            </Box>
          ) : selectedEvent !== null ? (
            <Box position="absolute" bottom="0" w="100%" m="10px" pr="20px">
              <EventDetailHostCard
                id={selectedEvent.id}
                status={'hosted'}
                time={new Date(selectedEvent.start_time)}
                type={selectedEvent.type}
                court={selectedEvent.court}
                level={getSkillLevelDisplay(selectedEvent.skill_level)}
                host={selectedEvent.host}
                coaches={selectedEvent.coaches}
                players={selectedEvent.participants}
                description={selectedEvent?.description ?? ''}
                price={selectedEvent.fee}
                duration={selectedEvent.duration}
                onOpenWaitlist={() => {}}
                thumbnail={selectedEvent.image}
                location={selectedEvent.address}
                locationName={selectedEvent.title}
                onExtraOptionsOpen={() => {
                  setCurrentEventId(selectedEvent.id)
                  setCurrentEventDate(new Date(selectedEvent.full_start_time ?? selectedEvent.start_time))
                  onExtraOptionsOpen()
                }}
              />
            </Box>
          ) : (
            <></>
          )}
        </Box>
      )}
    </Box>
  )
}

export default EventsSection
